// extracted by mini-css-extract-plugin
module.exports = {"actions":"confirmCleanType_actions__2eia4"};